import getLocalString from "constants/Localization";
import { useCreateDailyFormInspectionQuestionMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateDailyFormInspectionQuestion() {
  const [mutation, { loading, data, error }] = useCreateDailyFormInspectionQuestionMutation({
    refetchQueries: ["getDailyFormInspectionQuestions", "customGetDailyFormInspection"],
  });

  const [createDailyFormInspectionQuestion, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createDailyFormInspectionQuestion",
    },
    {
      successMessage: getLocalString("fleet.create-inspection-question-success"),
      failureMessage: getLocalString("fleet.create-inspection-question-failure"),
    }
  );

  return [createDailyFormInspectionQuestion, context] as const;
}
